module.exports = __webpack_public_path__ + "img/messaging.916911e6.png";